<template>
  <div class="split-bar" :style="inputStyle">
  </div>
</template>

<script>
export default {
  name: 'SplitBar',
   props: ['inputStyle',
           ],
   computed: {
   }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .split-bar{
   
 }
</style>
